import { api } from "./client"

export const signupLink = async (email: string) => {
  try {
    await api.post("/users/code", {
      email,
    })
  } catch (error) {
    console.error("Error sending signup link:", error)
    throw error
  }
}

export const createUser = async (
  code: string,
  full_name: string,
  password: string,
): Promise<string> => {
  try {
    const response = await api.post("/users/", {
      code,
      full_name,
      password,
    })
    return response.data?.key || ""
  } catch (error) {
    console.error("Error creating user:", error)
    throw error
  }
}
